import { __rest } from "tslib";
import * as React from 'react';
export const Component = React.forwardRef((_a, ref) => {
    var { children, renderAs } = _a, props = __rest(_a, ["children", "renderAs"]);
    return React.createElement(renderAs, Object.assign(Object.assign({}, props), { ref }), children);
});
//# sourceMappingURL=GenericComponent.js.map